import { Empty } from "antd";
import { groupBy } from "lodash";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faDownLeftAndUpRightToCenter, faEye, faLayerGroup, faMap, faMountain, faPrint, faTableCellsLarge, faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { FooterPadrao } from "../../../Footer/styled";
import { Monitoramento } from "./styled";
import { TitleContainer } from "../../../ordemLaboratorio/mapaFertilidade/components/painelFiltro/styled";

//APP
import { objOrder } from "../../../../services/Afins";
import { listPragas } from "../tabelaPragas/meta";
import { PropriedadeItens } from "../../../../services/Propriedades";
import { leadZero, removerAcentos } from "../../../../utils";
import { TypeDetailsMonitoramento } from "../../../../features/Monitoramento/Monitoramento.dataDetails";
import { MonitoramentoMapCalorType } from "../..";
import { MoniNivelItemControleItens } from "../../../../services/monitoramento/nivelControleItens";
import { MonitoramentoMapaCalorMonitoramentoType, obterTalhoes, processarTodosTalhoes } from "./meta";

//COMPONENTS
import Tabs from "../../../Tabs";
import Input from "../../../CustomUi/input";
import Carregando from "../../../CustomUi/loading";
import ButtonCustom from "../../../ButtonCustom";
import ProgressLoading from "../../../CustomUi/progressLoading";
import { Todos } from "./components/todos";
import { Render } from "../../../CustomUi/render";
import { Inline } from "../../../CustomUi/inline";
import { InfoBox } from "../../../CustomUi/infoBox";
import { Switcher } from "../../../CustomUi/Switcher";
import { PorTalhao } from "./components/porTalhao";
import { LineDivider } from "../../../CustomUi/LineDivider";
import { Agrupamento } from "./components/agrupamento";

//PROPS
interface Props {
    main_data: { [key: string]: MonitoramentoMapCalorType[] };
    all_data: { [key: string]: MonitoramentoMapaCalorMonitoramentoType[]; }[];
    progress: number;
    listDates: any;
    nome_safra: string;
    hideMarker: boolean;
    
    propriedade: PropriedadeItens;
    dataDetails: TypeDetailsMonitoramento;
    nome_cliente: string;
    nivelControle: MoniNivelItemControleItens[];
    setHideMarker: React.Dispatch<React.SetStateAction<boolean>>;
    groupTotalizar: boolean;
    nome_propriedade: string;
    disabilitarGerarBook: boolean;
    visibleChangeBooking: boolean;
    setVisibleChangeBooking: React.Dispatch<React.SetStateAction<boolean>>;
    setVisibleDrawerPonto: React.Dispatch<React.SetStateAction<boolean>>;
    onClose: Function;
    setCalorSelect: Function;
    handleClickBadge: Function;
    handleChangeCollapse: Function;
    handleAssembleHeatMap: Function;
    zoomNoMapaAgrupado: (coordenadas: { latitude: number, longitude: number }[]) => void;
}

export const PainelMonitoramento: React.FC<Props> = ({ main_data, all_data, propriedade, groupTotalizar, nivelControle, listDates,
    nome_cliente, nome_safra, nome_propriedade, handleAssembleHeatMap, handleClickBadge, setCalorSelect, handleChangeCollapse,
    progress, onClose, setHideMarker, hideMarker, dataDetails, disabilitarGerarBook, setVisibleChangeBooking, setVisibleDrawerPonto, 
    visibleChangeBooking, zoomNoMapaAgrupado }) => {

    //STATES
    const [current_tab, setCurrent_tab] = useState<'Por talhão' | 'Todos' | 'Agrupamento'>('Por talhão');
    const [search_talhao, setSearch_talhao] = useState<string>('');
    const [search_praga, setSearch_praga] = useState<string>('');
    const [pragas_talhao, setPragas_talhao] = useState<any>();
    const [encolher, setEncolher] = useState<boolean>(false);
    const [open_accordion, setOpen_accordion] = useState<number | null>(null);
    const [loading_todos_dados, setLoading_todos_dados] = useState<boolean>(true);
    const [list_todos_dados, setList_todos_dados] = useState([]);
    const [list_todos_dados_preserve, setList_todos_dados_preserve] = useState([]);
    const [fake_loading, setFake_loading] = useState<boolean>(false);
    //SELECIONADOS
    const [praga_selecionada, setPraga_selecionada] = useState<listPragas|null>(null);
    const [nome_praga_selecionada, setNome_praga_selecionada] = useState<string>('');
    const [nome_variacao_selecionada, setNome_variacao_selecionada] = useState<string>('');
    const [open_tabela_datas, setOpen_tabela_datas] = useState<boolean>(false);
    //AGRUPADOS
    const [pragas_agrupamento_talhoes, setPragas_agrupamento_talhoes] = useState<any>();

    useEffect(() => {
      return () => {
        setCurrent_tab('Por talhão');
        setSearch_talhao('');
        setEncolher(false);
        setOpen_accordion(null);
        setOpen_tabela_datas(false);
        setLoading_todos_dados(true);
      }
    }, [])
    

    //FUNCTIONS
      function fakeLoading() {
        setFake_loading(true);

        setTimeout(() => {
            setFake_loading(false);
            setVisibleChangeBooking?.(true);
        }, 700);
    }

    function obterDadosAgrupamentoSelecionado(dados_talhoes_agrupados: { cod_talhao: number; dados_monitoramento: MonitoramentoMapCalorType[] }[]) {

        if (Boolean(dados_talhoes_agrupados)==false) {
            return;
        }
        let remover_nulos = dados_talhoes_agrupados.filter((item)=> item!==null);
        
        let apenas_dados_monitoramento = remover_nulos.map(({ dados_monitoramento })=> {
            return dados_monitoramento ?? []
        });
        // @ts-ignore
        let mesclar_apenas_dados_monitoramento = apenas_dados_monitoramento.flat();

        let apenas_monitoramento = mesclar_apenas_dados_monitoramento.map(({ monitoramento })=> { return monitoramento });

        // @ts-ignore
        let mesclar_todos_monitoramentos = (apenas_monitoramento.flat()).flat();

        let agrupar_por_praga_e_variacao = groupBy(mesclar_todos_monitoramentos, 'codEspVari');

        const lista_pragas_agrupada_por_data = Object.entries(objOrder(agrupar_por_praga_e_variacao)).map(([info_praga, dados_monitoramento]: [any, any]) => {
            const pragas = groupBy(dados_monitoramento, 'dataInit')

            return { [info_praga]: { ...pragas } }
        });

        setPragas_agrupamento_talhoes(lista_pragas_agrupada_por_data);

        return lista_pragas_agrupada_por_data;
    }

    function obterDadosTalhaoSelecionado(cod_talhao: number) {

        const dados_talhao = main_data?.[cod_talhao];

        const monitoramento = dados_talhao.map((rec) => rec.monitoramento)

        let listMoni = []

        monitoramento.forEach((rec) => {
            rec.forEach((item) => {
                listMoni = [...listMoni, ...item]
            })
            return listMoni
        })

        const moniNivel = groupBy(listMoni, 'codEspVari');
        
        let totalizar = {}

        listMoni.forEach((item) => {
            const cod = item.codEspVari.split(', ')
            const codE = `${cod[0]}, ${cod[1]}` //ESPÉCIE
            const codV = `${cod[0]}, ${cod[1]}, ${cod[2]}` //VARIAÇÃO

            if (cod[3] === '1') {
                if (totalizar[codE] === undefined) {
                    totalizar[codE] = [item]
                } else {
                    totalizar[codE].push(item)
                }
            }
            else if (totalizar[codV] === undefined) {
                totalizar[codV] = [item]
            }
            else {
                totalizar[codV].push(item)
            }
        })

        const dateIsPraga = Object.entries(groupTotalizar ? objOrder(totalizar) : objOrder(moniNivel)).map(([dKey, dValue]: [any, any]) => {
            const pragas = groupBy(dValue, 'dataInit')

            return { [dKey]: { ...pragas } }
        });
        
        setPragas_talhao(dateIsPraga);
        return dateIsPraga

    }


    function buscarTalhao(buscar_nome: string) {
        const nomeSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const talhaoSemAcentos = removerAcentos(String(item?.['nome_talhao']))
            return talhaoSemAcentos.toLowerCase().includes(nomeSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    function processarTodosOsDados() {
        let processados = processarTodosTalhoes(all_data, nivelControle, listDates, groupTotalizar);
        let tempo_processamento = (processados??[]).length * 20;
        
        setList_todos_dados(processados);
        setList_todos_dados_preserve(processados);

        setTimeout(() => {
            setLoading_todos_dados(false);
        }, tempo_processamento);
    }

    useEffect(() => {

        setTimeout(() => {
           if (list_todos_dados_preserve.length > 0) {
                if (search_praga === '') {
                    setList_todos_dados(list_todos_dados_preserve);
                }
                if(search_praga.length > 0) {
                    let buscar_praga = list_todos_dados_preserve.filter(buscarPraga(search_praga));
                    setList_todos_dados(buscar_praga);
                }
            } 
        }, 300);
         
    }, [search_praga])

    function buscarPraga(buscar_nome: string) {
        const nomeSemAcentos = removerAcentos(buscar_nome);
        return function (item) {
          const pragaSemAcentos = removerAcentos(String(item?.['especie_nome']))
          const variacaoSemAcentos = removerAcentos(String(item?.['variacao']))
          return pragaSemAcentos.toLowerCase().includes(nomeSemAcentos.toLowerCase()) ||
            variacaoSemAcentos.toLowerCase().includes(nomeSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    return (
        <Monitoramento data-encolher={encolher}>
            <Inline justifyContent="space-between">
                <ButtonCustom
                    onClick={() => { onClose?.() }}
                    icon={<FontAwesomeIcon icon={faAngleLeft} />}
                    type="tertiary"
                    danger
                    style={{ marginLeft: -10 }}
                >
                    Voltar
                </ButtonCustom>
                <ButtonCustom
                    onClick={() => { setEncolher(!encolher) }}
                    icon={<FontAwesomeIcon icon={encolher ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter} />}
                    type="tertiary"
                    title={encolher? 'Expandir painel' : 'Encolher painel'}
                />
            </Inline>
            
            <Render condition={!encolher}>
                <TitleContainer data-esconder={encolher}>
                    <div className="TitleContainer__icon">
                        <FontAwesomeIcon icon={faMap} />
                    </div>
                    <div className="TitleContainer__titles">
                        <h2 className="TitleContainer__titles__talhao">
                            {nome_propriedade}
                        </h2>
                    </div>
                </TitleContainer>
            </Render>
            
            <InfoBox
                items={[
                    { title: 'Cliente', value: nome_cliente },
                    { title: 'Safra', value: nome_safra },
                    { title: 'Qtde de talhões', value: leadZero((obterTalhoes(main_data)?.length ?? 0)) },
                ]}
                spaceBetWeen
            />
            <LineDivider />

            <div style={{ height: 'calc(100% - 235px)', marginTop: 15, position: 'relative', zIndex: `997 !important` }}>

                <div className="Monitoramento__loading" style={{ display: (progress === 100 || progress === Infinity) && 'none' }}>
                    <ProgressLoading
                        width={590}
                        justifyContent="center"
                        legenda="Carregando lista de talhões"
                        animation
                        progress={progress}
                        trigger={() => {}}
                    />
                </div>
 
                <Inline style={{ marginTop: -8 }}>
                    <Tabs
                        width={393}
                        tabs={[
                            { descricao: 'Por talhão', icone: faMountain, task: ()=>{setLoading_todos_dados(true);setSearch_praga('')} },
                            { descricao: 'Todos', icone: faLayerGroup, task: ()=>{processarTodosOsDados();setSearch_talhao('')} },
                            { descricao: 'Agrupamento', icone: faTableCellsLarge, task: ()=>{processarTodosOsDados();setSearch_talhao('')} },
                        ]}
                        onChange={setCurrent_tab}
                        selecionado={current_tab}
                        trackWidth={127.5}
                    />

                    <Input
                        value={current_tab==='Por talhão' ? search_talhao : search_praga}
                        onChange={current_tab==='Por talhão' ? setSearch_talhao : setSearch_praga}
                        placeholder={current_tab==='Por talhão' ? "buscar talhão" : 'buscar praga'}
                        width={180}
                    />
                </Inline>

                <Render condition={current_tab === 'Por talhão' && obterTalhoes(main_data).length === 0}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Nenhum registro disponível!</>} />
                </Render>

                <Render condition={current_tab === 'Por talhão' && obterTalhoes(main_data).length > 0}>

                    <PorTalhao 
                        buscarTalhao={buscarTalhao}
                        search_talhao={search_talhao}
                        main_data={main_data}
                        propriedade={propriedade}
                        pragas_talhao={pragas_talhao}
                        listDates={listDates}
                        nivelControle={nivelControle}
                        groupTotalizar={groupTotalizar}
                        dataDetails={dataDetails}
                        encolher={encolher}
                        open_accordion={open_accordion}
                        setOpen_accordion={setOpen_accordion}
                        setVisibleDrawerPonto={setVisibleDrawerPonto}
                        visibleChangeBooking={visibleChangeBooking}
                        handleAssembleHeatMap={handleAssembleHeatMap}
                        handleClickBadge={handleClickBadge}
                        setCalorSelect={setCalorSelect}
                        handleChangeCollapse={handleChangeCollapse}
                        obterDadosTalhaoSelecionado={obterDadosTalhaoSelecionado}
                    />

                </Render>

                <Render condition={current_tab === 'Todos' && list_todos_dados.length === 0}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Nenhum registro disponível!</>} />
                </Render>

                <Render condition={current_tab === 'Todos' && list_todos_dados.length > 0}>
                    {loading_todos_dados
                    ? 
                        <div style={{height: 'calc(100vh - 320px)',display:'flex',alignContent:'center',justifyContent:'center'}}>
                            <Carregando legenda="Processando dados do monitoramento..." animation justifyContent="center"/>
                        </div>
                    : 
                        <Todos 
                            list_todos_dados={list_todos_dados}
                            setPraga_selecionada={setPraga_selecionada}
                            setNome_praga_selecionada={setNome_praga_selecionada}
                            setNome_variacao_selecionada={setNome_variacao_selecionada}
                            setOpen_tabela_datas={setOpen_tabela_datas}
                            search_talhao={search_talhao}
                            open_tabela_datas={open_tabela_datas}
                            encolher={encolher}
                            nome_praga_selecionada={nome_praga_selecionada}
                            nome_variacao_selecionada={nome_variacao_selecionada}
                            setVisibleDrawerPonto={setVisibleDrawerPonto}
                            praga_selecionada={praga_selecionada}
                            dataDetails={dataDetails}
                            visibleChangeBooking={visibleChangeBooking}
                            handleAssembleHeatMap={handleAssembleHeatMap}
                            handleClickBadge={handleClickBadge}
                            setCalorSelect={setCalorSelect}
                        />
                    }
                </Render>

                <Render condition={current_tab === 'Agrupamento' && list_todos_dados.length > 0}>
                    <Agrupamento 
                        main_data={main_data}
                        zoomNoMapaAgrupado={zoomNoMapaAgrupado}
                        obterDadosAgrupamentoSelecionado={obterDadosAgrupamentoSelecionado}
                        pragas_agrupamento_talhoes={pragas_agrupamento_talhoes}
                        listDates={listDates}
                        nivelControle={nivelControle}
                        handleAssembleHeatMap={handleAssembleHeatMap}
                        handleClickBadge={handleClickBadge}
                        setCalorSelect={setCalorSelect}
                        dataDetails={dataDetails}
                        encolher={encolher}
                        setVisibleDrawerPonto={setVisibleDrawerPonto}
                        visibleChangeBooking={visibleChangeBooking}
                        cod_propriedade={propriedade?.cod}
                    />
                </Render>


            </div>

            <FooterPadrao>

                <Switcher
                    isChecked={hideMarker}
                    trigger={setHideMarker}
                    label='Exibir marcadores'
                    disabled={progress < 100}
                />

                <ButtonCustom
                    onClick={() => { fakeLoading() }}
                    icon={<FontAwesomeIcon icon={faPrint} />}
                    disabled={progress < 100 || disabilitarGerarBook || fake_loading}
                    loading={fake_loading}
                >
                    Gerar book completo
                </ButtonCustom>
            </FooterPadrao>

        </Monitoramento>
    )
};